import StatusDialog from './StatusDialog.vue';

StatusDialog.install = function install(Vue) {
  Vue.component(StatusDialog.name, StatusDialog);
};

export default StatusDialog;



// WEBPACK FOOTER //
// ./src/components/statusDialog/index.js